module.exports = __webpack_public_path__ + "img/home_floating-picture2——vi.44f89f8f.png";